<template>
  <div>
    <div
      class="form-group variable-selector">
      <grid-row column-align="left" col-spaced>
        <grid-col col-size="1">
          <vue-single-select
            :placeholder="''"
            class="selection-left"
            v-model="symbolOp"
            v-on:input="updateModel"
            :options="operators"
            :hidden="hideOperator"
          />
        </grid-col>
        <grid-col col-size="1">
          <h2 v-if="isComparation && disabled">level.value</h2>
          <div v-else>
            <vue-single-select
              v-if="!isConstant"
              :placeholder="''"
              class="selection-left"
              v-model="variable"
              v-on:input="updateModel"
              :options="variables"
              :disabled="disabled"/>
            <label-input
              type="Number"
              ref="constantValue"
              v-else
              form-size="m"
              :margin="false"
              :value="constantValue ? constantValue.toString() : ''"
              v-on:input="updateConstantValue"
            />
          </div>
        </grid-col>
        <grid-col col-size="1" >
          <vue-single-select
            v-if="!isConstant"
            :placeholder="''"
            class="selection-left"
            v-model="op"
            :option-label="'label'"
            v-on:input="updateModel"
            :options="variableOperations"
          />
        </grid-col>
        <grid-col col-size="1" v-if="!disabled">
          <toggle-switch
            v-on:change="onToggleSelectionChange"
            :first="radioFirst"
            :second="radioSecond"
            :selected="varOrConst"/>
        </grid-col>
      </grid-row>
    </div>
  </div>
</template>

<script>

import VariableSelectorModal from '@/components/variable/VariableSelectorModal';
import vSelect from 'vue-select';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import BtnPill from '@/components/shared/buttons/BtnPill';
import VueSingleSelect from 'vue-single-select';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import ToggleSwitch from '@/components/shared/forms/ToggleSwitch';
import LabelInput from '@/components/shared/forms/LabelInput';

export default {
  name: 'FormulaComparationSelector',
  components: {
    GridCol,
    GridRow,
    BtnPill,
    vSelect,
    VariableSelectorModal,
    FontAwesomeIcon,
    VueSingleSelect,
    ToggleSwitch,
    LabelInput
  },
  props: {
    value: {
      type: Object,
      default: () => {
      }
    },
    variables: {
      type: Array,
      default: () => []
    },
    operators: {
      type: Array,
      default: () => []
    },
    variableOperations: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isComparation: {
      type: Boolean,
      default: false
    },
    hideOperator: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      variable: null,
      symbolOp: null,
      op: null,
      constantValue: null,
      varOrConst: 'constant',
      radioFirst: {name: 'constant', label: this.$t('rule.constant')},
      radioSecond: {name: 'variable', label: this.$t('rule.variable')}
    };
  },
  watch: {
    value: {
      handler: function (value) {
        if (this.value == null) {
          return;
        }
        this.variable = value.variable;
        this.symbolOp = value.symbolOp;
        this.op = value.op;
      }
    },
    varOrConst () {
      if (this.varOrConst === 'constant') {
        this.variable = null;
        this.op = null;
      } else {
        this.constantValue = null;
      }
    }
  },
  computed: {
    isConstant () {
      return this.varOrConst === 'constant';
    }
  },
  methods: {
    updateModel () {
      const model = {
        variable: !this.isConstant ? this.variable : null,
        op: !this.isConstant ? this.op : null,
        constantValue: this.isConstant ? this.constantValue : null,
        symbolOp: this.symbolOp
      };
      this.$emit('input', model);
    },
    onToggleSelectionChange (event) {
      this.varOrConst = event.target.value;
    },
    updateConstantValue (value) {
      this.constantValue = value;
      this.updateModel();
    }
  }
};
</script>

<style scoped>

.center-wrapper {
  display: flex;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/brand/health/components/challenge/FormulaComparationSelector.vue